import Form from './form'
import React, { useMemo, useState } from 'react'
import { featureBannerPlacementDetailPromise } from 'api/FeatureBanner'

export default function CourseAdd (props) {
  const { id } = props.match.params
  const [data, setData] = useState({})

  useMemo(() => {
    if (!id) return

    featureBannerPlacementDetailPromise(id).then(resp => {
      resp && setData(resp)
    })
  }, [id])

  return <Form data={data} setData={setData} {...props} />
}